// extracted by mini-css-extract-plugin
module.exports = {"tooltipArrow":"_12YrCVu","form":"_-23X8zo","pagination":"_3FXj1p7","buttonsWrapper":"_1uBqT5U"};